<template>
  <div>
    <b-card>
      <div class="row">
        <div class="col">
          <div class="form-group">
            <label>Qts</label>
            <input class="form-control personalise" v-model="qts" />
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <div class="form-group">
            <label>Prix</label>
            <input class="form-control personalise" v-model="prix" />
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col">
          <div class="form-group">
            <label>Titre</label>
            <input class="form-control personalise" v-model="titre" />
          </div>
        </div>
      </div>

      <CButton
        @click.prevent="add"
        type="submit"
        size="sm"
        color="info"
        style="border-radius: 24px; margin-left: 22px"
        ><CIcon name="cil-check-circle" /> Ajouter Traitement Vidange</CButton
      >

      <br /><br />
    </b-card>
  </div>
</template>


<script>
import { apiDomain } from "../../config";
import axios from "axios";

export default {
  props: {
    tableHeaderColor: {
      type: String,
      default: "",
    },
  },
  components: {},
  data() {
    return {
      qts: "",
      prix: "",
      titre: "",
      updateIn: false,
      info_trait_service_id: {},
      info_facture: {},
    };
  },

  created() {
    this.fetch_get_update_trait_service();
  },

  computed: {
    somme: function () {
      var sum = 0;
      /* for (var i = 0; i < this.all_service.length; i++) {
        sum += this.all_service[i].prix * this.all_service[i].qts;
      } */
      if (this.qts != "" && this.prix != "") {
        sum = Number(this.qts * this.prix) + this.info_facture.somme;
      }
      return sum;
    },

    somme_fr() {
      const { NumberToLetter } = require("convertir-nombre-lettre");
      return NumberToLetter(this.somme);
    },
  },

  methods: {
    add(e) {
      this.updateIn = true;
      let formData = new FormData();
      /* this.errors=[]; */

      /*  if (this.info_trait_service_id[0].Type == "null") {
        const type = "";
        formData.append("Type", type);
      } else {
        formData.append("Type", this.info_trait_service_id[0].Type);
      } */
      formData.append("titre", this.titre);
      formData.append("qts", this.qts);
      formData.append("prix", this.prix);

      formData.append("somme", this.somme);
      formData.append("somme_fr", this.somme_fr);

      formData.append("service_id", this.info_trait_service_id.service_id);

      axios
        .post(
          `${apiDomain}/api/addTraitVidange/${this.$route.params.id}`,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        )

        .then((res) => {
          this.updateIn = false;
          this.$noty.success("modifiée avec succés ! ");

          this.$router.go(-1);
        })
        .catch((error) => {
          this.updateIn = false;
        });
    },

    fetch_get_update_trait_service() {
      fetch(`${apiDomain}/api/get_TraitVidange/${this.$route.params.id}`)
        .then((res) => res.json())
        .then((res) => {
          this.info_trait_service_id = res.Traitement;
          this.info_facture = res.Facture;
        })
        .catch((err) => console.log(err));
    },
  },
};
</script>

<style>
.feed {
  background: #fff;
  height: 106px;
  overflow: scroll;
}
.btdelete {
  padding: 11px 27px !important;
  margin-top: 38px;
  border-radius: 5px;
}
/* 
.md-card img {
  width: 55% !important;
  height: auto;
} */

.non_paye {
  position: absolute;
  background: #f10735;
  opacity: 0.8;
  display: inline-block;
  padding: 0 10px;
  color: #fff;
  font-size: 13px;
  font-weight: 500;
  z-index: 1;
  margin-left: -1.4%;
  /*  margin-top: -15.6%; */

  margin-top: -16.6% !important;

  height: 30px;
  line-height: 30px;
  border-radius: 15px;
}

.paye {
  position: absolute;
  background: #28e40c;
  opacity: 0.8;
  display: inline-block;
  padding: 0 10px;
  color: #fff;
  font-size: 13px;
  font-weight: 500;
  z-index: 1;
  margin-left: -1.4%;
  margin-top: -16.6% !important;
  height: 30px;
  line-height: 30px;
  border-radius: 15px;
}

.en_attente {
  position: absolute;
  background: #c37600;
  opacity: 0.8;
  display: inline-block;
  padding: 0 10px;
  color: #fff;
  font-size: 13px;
  font-weight: 500;
  z-index: 1;
  margin-left: -1.4%;
  /*   margin-top: -15.6%; */

  margin-top: -16.6% !important;

  height: 30px;
  line-height: 30px;
  border-radius: 15px;
}

nav {
  display: flex;
  justify-content: center;
}

.pagination {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
}

.pagination li {
  margin: 0 1px;
  padding: 11px 6px !important;
  text-decoration: none;
}

.pagination > .active > a,
.pagination > .active > a:focus,
.pagination > .active > a:hover,
.pagination > .active > span,
.pagination > .active > span:focus,
.pagination > .active > span:hover {
  background-color: #2a357d !important;

  color: #ffffff !important;
  -webkit-box-shadow: 0 4px 5px 0 rgb(28 159 228 / 14%),
    0 1px 10px 0 rgb(28 159 228 / 12%), 0 2px 4px -1px rgb(28 159 228 / 20%);
  box-shadow: 0 4px 5px 0 rgb(28 159 228 / 14%),
    0 1px 10px 0 rgb(28 159 228 / 12%), 0 2px 4px -1px rgb(28 159 228 / 20%);
}

.pagination > li > a,
.pagination > li > span {
  color: fff;
  list-style-type: cercle;
  border: 0;
  border-radius: -16px !important;
  -webkit-transition: all 0.3s;
  transition: all 0.3s;
  padding: 9px;
  margin: 0 3px;
  min-width: 31px;
  height: 31px;
  line-height: 30px;
  color: #999999;
  font-weight: 400;
  font-size: 11px;
  text-transform: uppercase;
  background: transparent;
  /* border-color: blue !important; */
  border-radius: 4px;
  background-color: #e88e08 !important;
  /* border-color: #000; */
  color: #fff !important;
}

.index {
  display: inline-block;
  height: 36px;
  width: 36px;
  line-height: 36px;
  font-size: 11px;
  font-weight: 700;
  color: #fff;
  background-color: #e88e08;
  border-radius: 50% !important;
  text-align: center;
  position: relative;
  z-index: 2;
}

.index_new {
  display: inline-block;
  height: 25px;
  width: 25px;
  line-height: 28px;
  font-size: 11px;
  font-weight: 700;
  color: #fff;
  background-color: #e88e08;
  border-radius: 50% !important;
  text-align: center;
  position: relative;
  z-index: 2;
}

.cer {
  color: rgb(255, 255, 255);
  width: 30px;
  height: 30px;
  line-height: -10px;
  border-radius: 50%;
  font-size: 50px;
  text-align: center;
  background: rgb(245 175 19);
}
.cer_green {
  color: rgb(255, 255, 255);
  width: 30px;
  height: 30px;
  line-height: -10px;
  border-radius: 50%;
  font-size: 50px;
  text-align: center;
  background: #0ef717;
}
</style>

